import * as React from 'react';
import {
  ITabDetail,
  Tabcontroller,
} from '../../../core/components/tab-controller/tab-controller';
import { Controller, useForm } from 'react-hook-form';
import { toastr } from 'react-redux-toastr';
import { format } from 'date-fns';
import AddEmailForm from './AddEmailForm';
import AddSMSForm from './AddSMSForm';
import AddNotificationsForm from './AddNotificationsForm';
import api from '../../../api';
import ErrorMessage from '../../../components/text/ErrorMessage';
import {
  NotificationTemplate,
  INotificationTemplateItem,
  WappNotificationTemplate,
} from '../../../core';
import AddWappForm from './AddWappForm';
import CheckBox from '../../../components/check-box';

export const TemplateTabbedContent: React.FunctionComponent<{
  templateDetails: NotificationTemplate;
  realod: () => void;
}> = (props) => {
  const [tabs, setTabs] = React.useState<ITabDetail[]>([
    {
      text: 'Email',
      isActive: true,
      content: props.templateDetails?.templates?.email ? (
        <EmailTemplate
          templateDetails={props.templateDetails?.templates?.email}
          templateKey={props.templateDetails?.key}
          subject={props.templateDetails?.templates?.email?.subject}
          realod={props.realod}
        ></EmailTemplate>
      ) : (
        <></>
      ),
    },
    {
      text: 'SMS',
      content: props.templateDetails?.templates?.sms ? (
        <SmsTemplate
          templateDetails={props.templateDetails?.templates?.sms}
          templateKey={props.templateDetails?.key}
          subject={props.templateDetails?.templates?.email?.subject}
          realod={props.realod}
        ></SmsTemplate>
      ) : (
        <></>
      ),
    },
    {
      text: 'WhatsApp',
      content: props.templateDetails?.templates?.wapp ? (
        <WAPPTemplate
          templateDetails={props.templateDetails?.templates?.wapp}
          templateKey={props.templateDetails?.key}
          subject={props.templateDetails?.templates?.wapp?.subject}
          realod={props.realod}
        ></WAPPTemplate>
      ) : (
        <></>
      ),
    },
    {
      text: 'Notifications',
      content: props.templateDetails?.templates?.notification ? (
        <Notification
          templateDetails={props.templateDetails?.templates?.notification}
          templateKey={props.templateDetails?.key}
          subject={props.templateDetails?.templates?.email?.subject}
          realod={props.realod}
        ></Notification>
      ) : (
        <></>
      ),
    },
  ]);

  return (
    <div className="col-md col-12">
      <h4 className="font-weight-semibold mb-0 p-4">
        {props.templateDetails?.templates?.email?.subject}
      </h4>
      <Tabcontroller
        fontClass=""
        onChange={(index: number) => {
          const clone = [...tabs];
          clone.forEach((p, i) => {
            i === index ? (p.isActive = true) : (p.isActive = false);
          });
        }}
        tabs={tabs}
      ></Tabcontroller>
    </div>
  );
};

export const EmailTemplate: React.FunctionComponent<{
  templateDetails: INotificationTemplateItem;
  templateKey: string;
  subject: string;
  realod: () => void;
}> = (props) => {
  const [emailModal, setEmailModal] = React.useState<{
    isOpen?: boolean;
    template?: INotificationTemplateItem;
    isEdit?: boolean;
  }>({});

  const { control, handleSubmit, errors } = useForm<{
    email: string;
  }>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const onSendEmail = async (data?: any) => {
    const updateData: any = {
      key: props.templateKey,
      type: 'email',
      to: data.email,
    };

    try {
      await api.settings.testTemplateContent(updateData);
      toastr.success('Success', 'Email sent successfully');
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error('Error', error?.response?.data?.data?.message.join());
      } else {
        toastr.error('Error', error?.response?.data?.message);
      }
    }
  };

  return (
    <div className="px-4 py-4 bg-gray-100">
      <div className="tab-content" id="activity-tabContent">
        <div
          className="tab-pane fade show active"
          id="note"
          role="tabpanel"
          aria-labelledby="note-tab"
        >
          <div className="row align-items-end mb-3">
            <div className="col-sm-9 col-12">
              <h6 className="mb-1">{props.templateDetails?.subject}</h6>

              {props.templateDetails?.updatedAt && (
                <div className="font-xs text-gray-500">
                  Last Updated:{' '}
                  {format(
                    new Date(props.templateDetails?.updatedAt),
                    'dd/MM/yyyy hh:mm a'
                  )}
                  {/* <span>.</span>
                  Ajith E Palakkad */}
                </div>
              )}
            </div>
            <div className="col-sm-3 col-12 text-sm-right">
              <div
                onClick={() => {
                  setEmailModal({
                    isOpen: true,
                    isEdit: false,
                    template: props.templateDetails,
                  });
                }}
                className="cursor-pointer icon-box d-inline-flex align-items-center justify-content-center bg-white border mr-2"
              >
                <i className="icon-visibility"></i>
              </div>
              <div
                onClick={() => {
                  setEmailModal({
                    isOpen: true,
                    isEdit: true,
                    template: props.templateDetails,
                  });
                }}
                className="cursor-pointer icon-box d-inline-flex align-items-center justify-content-center bg-white border"
              >
                <i className="icon-edit"></i>
              </div>
            </div>
          </div>
          <div
            className="template w-100 bg-white px-3 py-4"
            dangerouslySetInnerHTML={{
              __html: props.templateDetails?.messageTemplate,
            }}
          ></div>
          <div className="form-group font-weight-semibold mb-3 pt-3">
            <form onSubmit={handleSubmit(onSendEmail)}>
              <div className="row gutter-8">
                <div className="col-sm col-12">
                  <Controller
                    control={control}
                    rules={{
                      required: true,
                      validate: (value) => {
                        return !!value.trim();
                      },
                      maxLength: 50,
                    }}
                    name="email"
                    render={({ onChange, value, name }) => (
                      <input
                        type="text"
                        className="form-control rounded-sm font-weight-semibold"
                        placeholder="Email Address"
                        name={name}
                        value={value}
                        onChange={onChange}
                        id="email"
                      />
                    )}
                  />
                  {errors.email && (
                    <ErrorMessage>Subject is required</ErrorMessage>
                  )}
                </div>
                <div className="col-sm-auto col-12">
                  <button className="btn btn-primary py-2 font-weight-semibold font-normal h-100">
                    Send Test Mail
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {emailModal.isOpen && (
        <AddEmailForm
          onClose={() => setEmailModal({})}
          isEdit={emailModal.isEdit || false}
          template={emailModal.template}
          key={props.templateKey}
          subject={props.subject}
          realod={props.realod}
        />
      )}
    </div>
  );
};

export const SmsTemplate: React.FunctionComponent<{
  templateDetails: INotificationTemplateItem;
  templateKey: string;
  subject: string;
  realod: () => void;
}> = (props) => {
  const [smsModal, setSMSModal] = React.useState<{
    isOpen?: boolean;
    template?: INotificationTemplateItem;
    isEdit?: boolean;
  }>({});

  const { control, handleSubmit, errors } = useForm<{
    phone: string;
  }>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const onSendSms = async (data?: any) => {
    const updateData: any = {
      key: props.templateKey,
      type: 'sms',
      to: data.phone,
    };

    try {
      await api.settings.testTemplateContent(updateData);

      toastr.success('Success', 'SMS sent successfully');
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error('Error', error?.response?.data?.data?.message.join());
      } else {
        toastr.error('Error', error?.response?.data?.message);
      }
    }
  };

  return (
    <div className="px-4 py-4 bg-gray-100">
      <div className="tab-content" id="activity-tabContent">
        <div
          className="tab-pane fade show active"
          id="note"
          role="tabpanel"
          aria-labelledby="note-tab"
        >
          {props.templateDetails?.updatedAt && (
            <div className="font-xs text-gray-500">
              Last Updated:{' '}
              {format(
                new Date(props.templateDetails?.updatedAt),
                'dd/MM/yyyy hh:mm a'
              )}
              {/* <span>.</span>
              Ajith E Palakkad */}
            </div>
          )}
          <div className="d-flex mb-2 align-items-end">
            <div
              onClick={() => {
                setSMSModal({
                  isOpen: true,
                  isEdit: true,
                  template: props.templateDetails,
                });
              }}
              className="cursor-pointer icon-box d-inline-flex align-items-center justify-content-center bg-white border ml-auto crusor-pointer"
            >
              <i className="icon-edit"></i>
            </div>
          </div>
          <div className="template w-100">
            <div
              className="bg-white px-3 py-4"
              dangerouslySetInnerHTML={{
                __html: props.templateDetails?.messageTemplate,
              }}
            ></div>
          </div>
          <div className="form-group font-weight-semibold mb-3 pt-3">
            <form onSubmit={handleSubmit(onSendSms)}>
              <div className="row gutter-8">
                <div className="col-sm col-12">
                  <Controller
                    control={control}
                    rules={{
                      required: true,
                      validate: (value) => {
                        return !!value.trim();
                      },
                      maxLength: 50,
                    }}
                    name="phone"
                    render={({ onChange, value, name }) => (
                      <input
                        type="text"
                        className="form-control rounded-sm font-weight-semibold"
                        placeholder="Phone"
                        name={name}
                        value={value}
                        onChange={onChange}
                        id="phone"
                      />
                    )}
                  />
                  {errors.phone && (
                    <ErrorMessage>Phone is required</ErrorMessage>
                  )}
                </div>
                <div className="col-sm-auto col-12">
                  <button className="btn btn-primary py-2 font-weight-semibold font-normal h-100">
                    Send Test SMS
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {smsModal.isOpen && (
        <AddSMSForm
          onClose={() => setSMSModal({})}
          isEdit={smsModal.isEdit || false}
          template={smsModal.template}
          key={props.templateKey}
          subject={props.subject}
          realod={props.realod}
        />
      )}
    </div>
  );
};

export const Notification: React.FunctionComponent<{
  templateDetails: INotificationTemplateItem;
  templateKey: string;
  subject: string;
  realod: () => void;
}> = (props) => {
  const [norificationModal, setNorificationModal] = React.useState<{
    isOpen?: boolean;
    template?: INotificationTemplateItem;
    isEdit?: boolean;
  }>({});
  return (
    <div className="px-4 py-4 bg-gray-100">
      <div className="tab-content" id="activity-tabContent">
        <div
          className="tab-pane fade show active"
          id="note"
          role="tabpanel"
          aria-labelledby="note-tab"
        >
          {props.templateDetails?.updatedAt && (
            <div className="font-xs text-gray-500">
              Last Updated:{' '}
              {format(
                new Date(props.templateDetails?.updatedAt),
                'dd/MM/yyyy hh:mm a'
              )}
              {/* <span>.</span>
              Ajith E Palakkad */}
            </div>
          )}
          <div className="d-flex mb-2 align-items-end">
            <div
              onClick={() => {
                setNorificationModal({
                  isOpen: true,
                  isEdit: true,
                  template: props.templateDetails,
                });
              }}
              className="cursor-pointer icon-box d-inline-flex align-items-center justify-content-center bg-white border ml-auto crusor-pointer"
            >
              <i className="icon-edit"></i>
            </div>
          </div>
          <div className="template w-100">
            <div
              className="bg-white px-3 py-4 mb-4"
              dangerouslySetInnerHTML={{
                __html: props.templateDetails?.messageTemplate,
              }}
            ></div>
          </div>
        </div>
      </div>
      {norificationModal.isOpen && (
        <AddNotificationsForm
          onClose={() => setNorificationModal({})}
          isEdit={norificationModal.isEdit || false}
          template={norificationModal.template}
          key={props.templateKey}
          subject={props.subject}
          realod={props.realod}
        />
      )}
    </div>
  );
};

export const WAPPTemplate: React.FunctionComponent<{
  templateDetails: WappNotificationTemplate;
  templateKey: string;
  subject: string;
  realod: () => void;
}> = (props) => {
  const [wappModal, setWappModal] = React.useState<{
    isOpen?: boolean;
    template?: WappNotificationTemplate;
    isEdit?: boolean;
  }>({});

  // const { control, handleSubmit, errors } = useForm<{
  //   phone: string;
  // }>({
  //   reValidateMode: 'onChange',
  //   mode: 'onSubmit',
  // });

  // const onSendWapp = async (data?: any) => {
  //   const updateData: any = {
  //     key: props.templateKey,
  //     type: 'wapp',
  //     to: data.phone,
  //   };

  //   try {
  //     await api.settings.testTemplateContent(updateData);

  //     toastr.success('Success', 'Wapp send successfully');
  //   } catch (error) {
  //     if (error?.response?.data?.data?.message) {
  //       toastr.error('Error', error?.response?.data?.data?.message.join());
  //     } else {
  //       toastr.error('Error', error?.response?.data?.message);
  //     }
  //   }
  // };

  return (
    <div className="px-4 py-4 bg-gray-100">
      <div className="tab-content" id="activity-tabContent">
        <div
          className="tab-pane fade show active"
          id="note"
          role="tabpanel"
          aria-labelledby="note-tab"
        >
          {props.templateDetails?.updatedAt && (
            <div className="font-xs text-gray-500">
              Last Updated:{' '}
              {format(
                new Date(props.templateDetails?.updatedAt),
                'dd/MM/yyyy hh:mm a'
              )}
            </div>
          )}
          <div className="d-flex mb-2 align-items-end">
            <div
              onClick={() => {
                setWappModal({
                  isOpen: true,
                  isEdit: true,
                  template: props.templateDetails,
                });
              }}
              className="cursor-pointer icon-box d-inline-flex align-items-center justify-content-center bg-white border ml-auto crusor-pointer"
            >
              <i className="icon-edit"></i>
            </div>
          </div>
          <div className="template w-100">
            <div
              className="bg-white px-3 py-4 border-bottom"
              dangerouslySetInnerHTML={{
                __html: props.templateDetails?.approvedReferenceTemplate || '',
              }}
            ></div>
          </div>
          <div className="template w-100">
            <div
              className="bg-white px-3 py-4"
              dangerouslySetInnerHTML={{
                __html: props.templateDetails?.messageTemplate,
              }}
            ></div>
            <div className="template w-100">
              <h6 className="px-3 py-4">
                <CheckBox
                  id={`${props.templateDetails?.isDocumentTemplate || ''}`}
                  label=" Is Document Template?"
                  checked={props.templateDetails?.isDocumentTemplate}
                />
              </h6>
            </div>
            <div className="template w-100">
              <h6 className="px-3 py-4">
                <CheckBox
                  id={`${props.templateDetails?.useBrochureTemplate || ''}`}
                  label=" Use Brochure Template?"
                  checked={props.templateDetails?.useBrochureTemplate}
                />
              </h6>
            </div>
          </div>

          {/* <div className="form-group font-weight-semibold mb-3 pt-3">
            <form onSubmit={handleSubmit(onSendWapp)}>
              <div className="row gutter-8">
                <div className="col-sm col-12">
                  <Controller
                    control={control}
                    rules={{
                      required: true,
                      validate: (value) => {
                        return !!value.trim();
                      },
                      maxLength: 50,
                    }}
                    name="phone"
                    render={({ onChange, value, name }) => (
                      <input
                        type="text"
                        className="form-control rounded-sm font-weight-semibold"
                        placeholder="Phone"
                        name={name}
                        value={value}
                        onChange={onChange}
                        id="phone"
                      />
                    )}
                  />
                  {errors.phone && (
                    <ErrorMessage>Phone is required</ErrorMessage>
                  )}
                </div>
                <div className="col-sm-auto col-12">
                  <button className="btn btn-primary py-2 font-weight-semibold font-normal h-100">
                    Send Test Wapp
                  </button>
                </div>
              </div>
            </form>
          </div> */}
        </div>
      </div>
      {wappModal.isOpen && (
        <AddWappForm
          onClose={() => setWappModal({})}
          isEdit={wappModal.isEdit || false}
          template={wappModal.template}
          key={props.templateKey}
          subject={props.subject}
          realod={props.realod}
        />
      )}
    </div>
  );
};
